import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, { useContext } from "react";
import LanguageContext from "../../LanguageContext";
import config from "../../config";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

export default function Profit(props) {
  const classes = props.classes;
  const language = useContext(LanguageContext);
  const theme = useTheme();
  const isLargerThanSmall = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      className={classes.benefitContainer}
    >
      <Grid item xs={1} sm={4} md={5}></Grid>
      <Grid item xs={3} sm={1} md={1}>
        <img src={`${config.appUrl}${props.icon}`} height={"60"} alt="" />
      </Grid>

      <Grid item xs={7} sm={4} md={3}>
        <Typography
          variant={"body1"}
          className={
            isLargerThanSmall ? classes.profitTitleDesktop : classes.profitTitle
          }
        >
          {props.title}
        </Typography>
      </Grid>
      <Grid item xs={1} sm={3} md={3}></Grid>
    </Grid>
  );
}
